import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const MenBodyMeasurement: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 198 575" {...props}>
      <path
        d="M143.297 528.086C143.9 525.751 144.384 523.387 144.748 521.003C147.714 492.084 143.898 463.897 134.712 436.481C131.837 427.908 127.028 420.002 123.447 411.652C121.784 407.498 120.626 403.158 119.998 398.728C124.833 401.433 130.02 403.354 131.001 409.783C131.34 412.018 133 414.03 133.98 416.173C136.476 421.57 138.933 426.98 141.821 433.266C144.108 421.701 132.673 415.232 132.987 405.458L148.132 403.654C148.067 405.304 147.826 406.943 147.414 408.542C143.206 421.165 146.015 433.54 148.89 445.824C150.082 451.544 150.522 457.396 150.197 463.23C149.792 478.193 150.197 493.182 150.419 508.17C150.465 514.391 151.02 520.597 152.079 526.727C152.443 524.25 152.665 521.754 152.745 519.252C152.419 502.721 151.125 486.151 151.818 469.673C152.406 455.298 155.189 441.08 157.92 426.549C158.364 427.856 158.9 429.163 159.227 430.469C162.807 443.772 162.141 457.154 159.776 470.509C157.058 485.877 155.228 501.323 155.934 516.939C156.117 520.859 157.554 524.779 158.809 528.53C159.802 531.562 161.422 534.371 162.729 537.351C165.881 544.872 170.516 551.681 176.359 557.37C178.28 559.291 179.952 561.448 181.743 563.499L181.011 564.323L176.672 561.813L180.449 568.504L179.325 569.432L173.301 564.205L172.373 564.937L176.868 570.595C175.823 571.288 175.797 571.314 169.786 567.393C167.172 565.668 164.559 563.774 161.945 561.931C161.475 566.283 165.722 567.158 168.361 569.51L166.649 570.817C168.165 571.405 169.629 571.941 171.04 572.607C171.119 572.607 170.766 574.293 170.478 574.332C168.623 574.633 166.336 575.443 164.951 574.685C157.11 570.399 149.021 566.165 148.106 555.528C147.627 551.91 146.751 548.356 145.493 544.93C145.028 543.044 144.009 541.342 142.565 540.043C139.468 537.795 139.364 535.025 140.083 531.862C143.467 516.991 141.389 502.656 136.162 488.582C133.849 482.427 132.072 476.05 129.563 469.973C124.637 458.003 128.335 446.7 131.484 434.847C142.418 464.661 145.96 496.681 141.808 528.164L143.297 528.086Z"
        fill="url(#paint0_linear_7074_113690)"
      />
      <path
        d="M49.9284 403.655L65.6097 405.419C64.6819 408.033 63.911 410.869 62.7218 413.495C60.7094 417.938 58.2657 422.198 56.3186 426.668C55.6129 428.288 55.8612 430.313 55.6652 432.143L56.8413 432.417C57.5078 430.823 58.1482 429.216 58.8538 427.661C60.9969 423.113 63.2184 418.592 65.3877 414.044C66.2206 412.597 66.8329 411.033 67.2041 409.405C68.0927 403.159 73.2807 401.355 77.3317 398.363L78.4424 398.938C77.7079 402.444 76.7388 405.898 75.5414 409.274C72.771 415.808 69.3865 422.172 66.5769 428.732C64.5771 433.493 62.8322 438.357 61.3498 443.303C55.2341 463.27 51.8233 483.656 52.5551 504.617C52.7511 510.367 53.0387 516.103 53.4961 521.84C53.725 524.053 54.4341 526.189 55.5738 528.1C52.3461 496.123 55.6521 465.034 66.6029 434.717C70.2096 446.949 73.2936 458.932 68.1057 471.66C64.2039 481.257 60.9386 491.101 58.3311 501.128C55.5853 511.2 55.4953 521.811 58.0698 531.928C58.8669 535.012 58.5009 537.548 55.7044 539.769C54.2144 541.203 53.132 543.007 52.5681 544.996C51.4913 547.739 50.7838 550.613 50.4643 553.543C49.7194 563.997 42.8981 569.55 34.5609 573.994C34.1161 574.341 33.5975 574.583 33.045 574.699C31.2957 574.716 29.5478 574.593 27.8179 574.333C27.465 574.333 27.0076 572.674 27.0729 572.634C28.3797 571.903 29.8694 571.328 31.3199 570.635L30.1309 569.707L37.1483 562.442L36.1159 561.344C31.895 565.617 26.6418 568.231 22.2902 572.308L21.1664 570.779L25.7271 564.598L25.0213 564.01L18.7228 569.237L17.6119 568.479L21.5322 561.749L16.9716 564.271L16.2529 563.526C17.9125 561.592 19.4414 559.606 21.2447 557.763C27.6872 551.347 31.6989 543.389 36.2073 535.64C44.8059 520.769 42.3231 505.296 41.0163 489.785C39.8271 475.842 37.3835 461.99 36.6255 447.968C36.2335 440.755 38.2851 433.397 39.2391 426.119H41.343C43.1594 442.911 45.6292 459.677 46.5701 476.521C47.524 493.156 44.6099 509.87 45.7206 526.558H46.7661C47.2104 516.508 47.7201 506.459 48.0729 496.41C48.5695 483.342 49.6019 470.379 47.4718 457.377C47.0798 454.998 47.7854 452.385 48.2166 449.928C49.7456 441.094 52.0062 432.326 52.7511 423.44C53.1824 418.213 51.3006 412.698 50.4773 407.314C50.2421 405.916 50.046 404.439 49.9284 403.655Z"
        fill="url(#paint1_linear_7074_113690)"
      />
      <path
        d="M74.4565 27.2234C74.7995 23.3861 75.4374 19.5808 76.3645 15.8414C79.9712 3.94972 89.1055 -1.21203 103.049 0.238494C114.431 1.41459 122.781 9.38591 122.807 22.0486C122.807 33.8096 120.899 45.7404 118.495 57.3315C117.698 61.1473 113.085 64.5841 109.557 67.3284C99.7427 74.96 98.6581 74.4111 88.2431 67.5244C80.6246 62.4803 77.789 55.4629 76.8742 47.0734C76.1816 41.0753 75.4889 35.0902 74.4565 27.2234Z"
        fill="url(#paint2_linear_7074_113690)"
      />
      <path
        d="M61.2047 367.94C60.7857 367.368 60.4267 366.755 60.1332 366.11C54.8146 346.796 49.1041 327.534 50.5677 307.122C51.2472 297.753 52.4754 288.828 57.7679 280.373C64.3017 270.023 67.7647 258.249 69.8686 244.75C72.5867 247.886 75.4356 249.886 76.481 252.591C81.0547 264.352 85.0404 276.622 84.9881 289.18C84.9881 299.386 82.0609 309.592 80.2183 319.759C77.1213 336.969 68.7578 352.062 61.2047 367.94Z"
        fill="url(#paint3_linear_7074_113690)"
      />
      <path
        d="M128.048 245.692C128.69 249.164 129.528 252.598 130.557 255.976C133.588 264.248 135.954 272.964 140.397 280.426C145.559 289.077 147.074 298.185 147.466 307.672C148.231 322.411 146.287 337.164 141.73 351.201C139.978 356.428 138.972 362.008 137.43 368.189C136.516 366.765 136.006 366.059 135.588 365.288C124.742 345.451 118.051 324.242 113.817 302.04C111.465 289.783 114.379 278.401 116.901 266.757C117.698 263.072 119.331 259.583 120.233 255.911C121.344 251.455 124.088 248.358 128.048 245.692Z"
        fill="url(#paint4_linear_7074_113690)"
      />
      <path
        d="M97.7037 147.841C97.4815 154.91 96.0049 156.374 89.079 156.988C81.173 157.628 73.2538 158.478 65.3217 158.674C60.565 158.805 56.9452 156.06 54.3448 151.97C51.7443 147.88 49.2223 144.286 46.6349 140.47C44.4958 137.263 43.6034 133.384 44.1257 129.564C44.648 125.744 46.5489 122.247 49.4705 119.732C53.2863 116.452 57.3112 113.316 60.9702 109.944C62.6993 108.492 64.1285 106.716 65.178 104.717C67.5433 99.5683 71.3591 99.0848 76.2073 100.3C80.402 101.372 84.6882 102.077 88.9483 102.914C94.672 104.037 97.2332 106.638 97.4945 112.571C97.7559 118.504 97.5599 124.606 97.5599 130.617H97.7429C97.7037 136.354 97.8997 142.104 97.7037 147.841Z"
        fill="url(#paint5_linear_7074_113690)"
      />
      <path
        d="M150.642 141.54C148.537 144.335 146.583 147.24 144.788 150.244C140.867 157.601 134.333 159.626 126.767 159.104C119.789 158.607 112.863 157.548 105.859 156.712C103.245 156.398 101.285 155.092 101.089 152.269C100.592 144.886 100.24 137.502 99.7822 130.054H100.397C100.397 124.173 100.24 118.293 100.397 112.425C100.566 106.898 103.284 103.997 108.642 102.925C113.569 101.945 118.495 100.887 123.435 99.9196C127.159 99.1878 129.577 100.259 132.19 103.579C136.783 109.048 141.861 114.091 147.362 118.646C154.941 125.323 156.274 133.308 150.642 141.54Z"
        fill="url(#paint6_linear_7074_113690)"
      />
      <path
        d="M141.599 207.519C141.011 213.661 140.593 219.816 139.783 225.932C139.555 228.397 138.805 230.785 137.581 232.937C136.358 235.089 134.689 236.956 132.687 238.411C120.586 246.788 116.143 259.385 112.902 272.832C111.664 277.702 110.159 282.501 108.394 287.206C107.48 289.409 106.276 291.479 104.813 293.361C100.762 298.941 96.7504 299.255 93.4181 293.361C90.0859 287.468 87.7598 280.66 85.3814 274.126C82.6503 266.638 81.0952 258.627 77.5408 251.571C75.2278 246.919 70.6411 243.194 66.5378 239.679C61.3107 235.184 58.3313 229.93 57.9 223.057C57.5603 217.738 56.7501 212.446 56.5933 207.14C56.5933 205.259 57.6125 203.338 58.1744 201.43C59.9386 202.384 61.9902 203.024 63.4015 204.344C68.1059 208.735 72.549 213.491 77.175 217.882C78.5033 219.093 80.125 219.935 81.8794 220.326C93.1471 222.776 104.81 222.776 116.078 220.326C117.95 219.897 119.682 218.997 121.109 217.712C125.709 213.413 130.008 208.787 134.608 204.474C136.226 203.263 137.98 202.246 139.835 201.443L142.318 207.245L141.599 207.519ZM122.69 220.587L121.449 219.581C114.653 224.729 106.59 224.808 98.9589 224.664C91.3273 224.52 83.761 222.443 75.9335 221.162C75.9682 222.645 76.1521 224.12 76.4824 225.566C79.0044 233.851 81.3305 242.214 84.323 250.303C87.0803 257.608 89.5501 265.592 100.331 264.547C102.945 264.299 104.761 264.09 106.551 262.26C113.582 254.994 115.699 245.416 118.874 236.347C120.677 231.316 121.462 225.906 122.69 220.639V220.587Z"
        fill="url(#paint7_linear_7074_113690)"
      />
      <path
        d="M191.623 311.918C190.015 308.52 195.687 306.782 193.923 303.554C190.381 307.109 187.715 310.977 184.03 313.094C181.299 314.675 177.261 313.996 173.798 314.335L173.498 312.793C174.386 312.467 175.262 312.127 176.111 311.813C178.391 311.217 180.62 310.439 182.776 309.487C187.166 307.135 187.559 303.973 183.808 300.98C183.22 300.501 182.532 300.159 181.796 299.978C181.059 299.798 180.291 299.783 179.548 299.935C177.17 300.993 173.955 301.686 174.086 305.436C174.086 307.723 174.164 310.01 169.695 310.128C170.505 305.763 170.623 301.529 172.152 297.896C174.334 292.734 176.555 287.625 180.776 283.273C185.219 278.7 186.5 272.296 187.545 265.658C189.297 254.459 192.955 243.573 196 231.825C196 238.83 196.092 245.128 196 251.427C195.909 256.314 195.451 261.215 195.36 266.102C195.292 267.789 195.623 269.468 196.327 271.003C198.339 274.923 197.843 278.399 196.902 282.62C195.7 287.965 196.249 293.767 196.471 299.347C196.706 304.365 194.406 308.102 191.623 311.918Z"
        fill="url(#paint8_linear_7074_113690)"
      />
      <path
        d="M2.68838 232.323C5.30193 243.835 10.529 254.669 10.6858 266.861C10.6858 274.296 14.7107 279.929 19.2844 285.809C24.5115 292.513 29.0199 300.184 27.5041 309.828C23.7405 310.468 23.7797 308.064 23.8973 305.607C24.0934 301.686 20.6696 300.876 18.1606 299.909C16.9453 299.439 14.593 300.667 13.3516 301.791C10.738 304.104 11.0779 307.018 14.1488 308.704C17.4257 310.337 20.7991 311.768 24.2502 312.99C22.6037 314.571 17.1804 315.381 13.0249 312.912C9.70565 310.952 7.52343 307.044 4.46558 303.568C1.85202 306.914 8.38591 308.508 5.77235 312.716C4.20422 308.416 2.32246 304.953 1.85202 301.294C1.22477 297.047 1.96954 292.617 1.76046 288.227C1.62978 285.495 0.767307 282.79 0.453681 280.046C0.218461 278.308 -0.369544 276.126 0.336116 274.819C3.64226 268.429 2.94976 261.751 2.38784 255.061C1.85207 247.573 1.5123 240.072 1.08107 232.571L2.68838 232.323Z"
        fill="url(#paint9_linear_7074_113690)"
      />
      <path
        d="M175.143 204.827C157.345 185.84 155.293 162.853 157.28 138.613C165.408 142.951 173.066 147.59 174.947 157.992C177.77 173.582 177.038 189.08 175.143 204.827Z"
        fill="url(#paint10_linear_7074_113690)"
      />
      <path
        d="M186.865 250.722C183.559 240.817 179.913 231.016 177.116 220.967C176.071 217.23 176.881 212.943 177.116 208.918C177.77 196.909 178.554 184.913 179.272 172.904C179.219 171.447 179.44 169.992 179.926 168.617C180.396 169.676 180.867 170.734 181.324 171.806C184.905 180.287 188.367 188.794 192.079 197.249C194.901 203.678 196.679 210.447 195.437 217.282C193.373 228.625 190.393 239.811 187.806 251.062L186.865 250.722Z"
        fill="url(#paint11_linear_7074_113690)"
      />
      <path
        d="M40.8591 138.523C42.4011 162.738 40.8591 185.855 22.708 204.895C22.2375 198.883 21.4012 193.134 21.4012 187.292C21.283 179.179 21.597 171.066 22.342 162.986C23.688 150.115 27.5431 145.397 40.8591 138.523Z"
        fill="url(#paint12_linear_7074_113690)"
      />
      <path
        d="M17.8722 169.011C19.0614 183.947 20.3943 199.001 21.3221 214.068C21.4065 217.678 20.8715 221.276 19.7408 224.706C17.1272 233.383 14.1347 241.955 11.0899 251.194C10.2797 248.711 9.41737 246.581 8.90773 244.386C6.68621 234.872 3.68051 225.411 2.7527 215.767C2.17772 209.821 4.12492 203.327 6.12429 197.472C9.14294 188.639 13.1939 180.158 16.8136 171.52L17.8722 169.011Z"
        fill="url(#paint13_linear_7074_113690)"
      />
      <path
        d="M81.3295 327.797C82.3488 348.862 86.8049 369.966 78.3893 390.365C77.0825 393.475 76.416 397.03 71.8554 396.899C68.0657 396.742 63.1785 392.9 62.4597 389.058C60.9169 380.74 62.1185 372.146 65.8835 364.569C70.418 354.978 74.7434 345.268 78.9513 335.546C79.9154 333.018 80.7098 330.43 81.3295 327.797Z"
        fill="url(#paint14_linear_7074_113690)"
      />
      <path
        d="M116.927 327.6C119.789 342.262 127.917 354.69 133.419 368.202C135.862 374.226 135.47 381.57 135.562 388.339C135.562 392.508 130.674 396.415 126.414 396.781C125.151 396.963 123.866 396.676 122.8 395.976C121.733 395.275 120.96 394.209 120.625 392.978C117.058 383.086 113.974 373.141 114.536 362.36C115.111 351.331 115.215 340.263 115.542 329.22C115.58 328.733 115.649 328.248 115.751 327.77L116.927 327.6Z"
        fill="url(#paint15_linear_7074_113690)"
      />
      <path
        d="M171.602 144.716C168.753 142.861 166.832 141.475 164.768 140.325C159.54 137.385 155.947 133.935 155.411 127.114C155.137 123.52 151.817 119.705 148.982 116.856C143.519 111.354 137.43 106.402 131.602 101.331L132.255 99.8676C137.142 99.2535 142.017 98.4432 146.93 98.1819C147.762 98.234 148.573 98.4585 149.313 98.8409C150.053 99.2233 150.706 99.7554 151.229 100.403C154.888 105.095 159.07 109.655 161.501 114.987C165.303 123.363 167.839 132.328 170.883 141.057C171.193 142.262 171.433 143.484 171.602 144.716Z"
        fill="url(#paint16_linear_7074_113690)"
      />
      <path
        d="M25.7271 143.463C30.4837 131.571 35.249 119.684 40.0231 107.801C40.3497 107.181 40.7489 106.602 41.2123 106.076C45.3679 100.509 50.033 96.2623 57.8345 98.6929C60.7652 99.366 63.7386 99.8375 66.7337 100.104C63.1009 103.92 60.1998 107.252 57.0243 110.245C54.267 112.858 51.1438 115.002 48.1774 117.341C46.2499 118.877 44.6891 120.823 43.6086 123.039C42.5281 125.254 41.955 127.682 41.931 130.147C41.9124 131.686 41.4775 133.191 40.6722 134.503C39.8669 135.814 38.7212 136.883 37.3572 137.596C33.8943 139.66 30.6012 142.013 27.2297 144.247L25.7271 143.463Z"
        fill="url(#paint17_linear_7074_113690)"
      />
      <path
        d="M48.0463 379.87C38.337 358.739 42.1005 336.603 46.8702 314.361C46.9924 317.14 47.2672 319.911 47.6935 322.659C50.6599 336.733 53.77 350.781 56.8409 364.842C57.1415 366.149 57.4944 367.56 57.7034 368.932C58.2915 372.774 57.4028 375.349 52.8683 376.067C51.1041 376.342 49.6929 378.459 48.0463 379.87Z"
        fill="url(#paint18_linear_7074_113690)"
      />
      <path
        d="M150.236 379.413C148.139 377.989 145.927 376.743 143.623 375.688C140.853 374.695 139.703 372.905 140.213 370.265C140.762 366.972 141.742 363.731 142.434 360.464C145.714 345.057 148.968 329.638 152.052 314.91C155.985 336.25 159.723 358.439 150.236 379.413Z"
        fill="url(#paint19_linear_7074_113690)"
      />
      <path
        d="M103.624 300.903C103.956 301.614 104.248 302.342 104.499 303.085C107.283 313.056 110.262 322.975 112.771 333.011C115.385 343.373 112.902 353.71 112.484 365.196C108.812 353.71 105.61 343.439 102.239 333.233C98.6321 322.373 102.644 311.749 103.624 300.903Z"
        fill="url(#paint20_linear_7074_113690)"
      />
      <path
        d="M94.7114 299.923C97.325 315.395 98.9062 329.456 92.6075 343.36C89.6673 349.894 88.2037 357.016 85.7339 363.85C85.1589 352.704 82.5324 341.635 85.9953 330.436C89.0009 320.727 91.5882 310.9 94.7114 299.923Z"
        fill="url(#paint21_linear_7074_113690)"
      />
      <path
        d="M133.602 166.528C131.241 167.886 128.802 169.103 126.297 170.174C125.798 170.426 125.253 170.577 124.696 170.619C124.138 170.661 123.577 170.593 123.045 170.418C122.514 170.244 122.022 169.966 121.598 169.601C121.174 169.236 120.825 168.791 120.573 168.292C119.315 166.65 117.609 165.406 115.66 164.711C110.455 162.484 104.855 161.326 99.1933 161.305C93.5316 161.285 87.9237 162.403 82.7029 164.594C81.0044 165.189 79.4441 166.123 78.1161 167.338C74.7054 170.892 72.5623 171.376 68.1585 168.789C66.8517 168.018 65.7018 166.985 63.4541 165.326C67.1392 163.731 69.9879 161.993 73.0458 161.301C78.4951 160.059 84.1404 159.68 89.6027 158.478C92.8461 157.567 96.0207 156.427 99.1028 155.067C102.065 156.421 105.123 157.556 108.25 158.465C113.856 159.68 119.632 160.112 125.238 161.327C128.113 161.967 130.779 163.601 133.537 164.79L133.602 166.528Z"
        fill="url(#paint22_linear_7074_113690)"
      />
      <path
        d="M31.5413 199.419C31.2277 206.175 32.2077 213.323 30.339 219.621C25.6738 235.303 19.7149 250.657 13.8737 267.293C13.0413 256.161 14.7667 244.986 18.9178 234.623C21.7012 227.423 24.1449 220.392 24.3148 212.408C24.4063 207.9 27.5426 203.456 29.2937 198.987L31.5413 199.419Z"
        fill="url(#paint23_linear_7074_113690)"
      />
      <path
        d="M108.001 201.73C101.689 201.534 100.343 200.097 99.9512 192.714C99.7944 189.917 99.9513 187.121 99.7944 184.324C99.6899 182.09 100.566 181.279 102.8 181.619C108.027 182.416 113.372 182.926 118.599 183.932C119.631 184.115 121.304 185.918 121.134 186.637C120.117 190.967 118.865 195.237 117.384 199.43C117.162 200.084 115.907 200.62 115.045 200.737C112.719 201.221 110.353 201.43 108.001 201.73Z"
        fill="url(#paint24_linear_7074_113690)"
      />
      <path
        d="M77.1226 184.168C83.4213 183.292 89.4978 182.351 95.5874 181.672C96.3453 181.58 98.0179 182.848 97.9918 183.449C97.9655 188.318 97.5899 193.179 96.868 197.994C96.6197 199.366 94.176 201.208 92.6079 201.352C80.9253 202.371 75.9073 196.817 77.1226 184.168Z"
        fill="url(#paint25_linear_7074_113690)"
      />
      <path
        d="M184.37 267.161C180.005 255.296 175.745 244.711 172.23 233.864C169.916 226.426 168.096 218.844 166.78 211.166C166.282 207.147 166.468 203.074 167.329 199.117C170.609 203.626 173.471 207.977 174.124 213.662C174.649 219.448 175.864 225.152 177.744 230.65C182.004 242.097 184.931 253.636 184.37 267.161Z"
        fill="url(#paint26_linear_7074_113690)"
      />
      <path
        d="M112.953 69.2363C108.118 81.7552 106.42 95.2934 100.069 107.329L98.4221 107.564C96.6242 104.456 95.0309 101.235 93.6523 97.92C91.47 91.752 89.6666 85.4272 87.8632 79.1285C86.9093 75.8224 86.269 72.4117 85.498 69.0402L86.9616 68.3738C88.0332 70.1118 89.5751 71.7061 90.1108 73.6009C92.5022 82.1864 94.5931 90.8503 97.1544 99.5273C96.6186 94.7053 96.0699 89.8964 95.4949 84.8H102.525L100.918 99.475C103.793 88.9163 104.995 77.9525 110.732 68.5045L112.953 69.2363Z"
        fill="url(#paint27_linear_7074_113690)"
      />
      <path
        d="M76.1948 181.881C76.9136 177.791 77.2401 174.759 78.0242 171.858C78.34 170.493 79.058 169.254 80.0853 168.301C81.1127 167.348 82.4021 166.726 83.7871 166.513C88.0733 165.52 92.1766 163.756 97.3515 161.979C97.3515 167.755 97.4691 172.707 97.2208 177.66C97.2208 178.366 95.4304 179.411 94.3589 179.568C88.7267 180.404 83.0554 181.032 76.1948 181.881Z"
        fill="url(#paint28_linear_7074_113690)"
      />
      <path
        d="M121.893 181.895C114.98 181.019 109.139 180.47 103.402 179.399C102.252 179.177 100.789 177.073 100.658 175.701C100.266 172.381 100.658 168.984 100.514 165.612C100.436 162.672 102.096 162.241 104.317 162.933C108.48 164.111 112.555 165.583 116.509 167.337C118.24 168.481 119.505 170.205 120.077 172.198C121.005 174.903 121.227 177.87 121.893 181.895Z"
        fill="url(#paint29_linear_7074_113690)"
      />
      <path
        d="M60.4607 376.538C60.4607 381.674 59.3108 386.809 60.8005 391.004C62.1857 394.924 66.3935 397.812 69.3207 401.105C66.7071 403.157 56.6841 404.176 53.7569 401.811C51.7845 400.328 50.2551 398.334 49.3338 396.045C48.4125 393.755 48.1345 391.258 48.5298 388.822C49.7059 380.929 52.1627 378.315 60.4607 376.538Z"
        fill="url(#paint30_linear_7074_113690)"
      />
      <path
        d="M127.512 400.688C140.083 396.415 137.966 386.157 137.966 376.918C144.604 377.467 146.957 379.532 148.904 386.066C150.472 391.293 148.904 399.133 144.853 401.368C139.521 404.321 133.68 403.224 127.512 400.688Z"
        fill="url(#paint31_linear_7074_113690)"
      />
      <path
        d="M142.944 278.571C137.138 267.932 133.208 256.372 131.327 244.398C131.276 243.952 131.321 243.499 131.459 243.071C131.596 242.643 131.823 242.249 132.124 241.915C134.737 239.485 137.612 237.224 140.383 234.911L141.807 235.159C142.134 249.429 142.552 263.699 142.944 278.571Z"
        fill="url(#paint32_linear_7074_113690)"
      />
      <path
        d="M97.2074 220.079C93.9666 220.079 91.6014 220.079 89.2361 220.079C80.9642 219.909 78.7818 217.649 78.5728 209.22C78.5728 207.417 78.5728 205.613 78.5728 203C84.2311 203.34 89.602 203.536 94.9336 204.124C95.783 204.215 97.0376 205.966 97.1029 207.012C97.3512 211.167 97.2074 215.336 97.2074 220.079Z"
        fill="url(#paint33_linear_7074_113690)"
      />
      <path
        d="M101.377 219.635C101.035 215.528 100.904 211.406 100.984 207.286C101.177 206.523 101.559 205.82 102.096 205.244C102.633 204.669 103.307 204.238 104.055 203.993C108.877 203.353 113.778 203.274 118.561 203C122.612 216.237 116.77 221.857 101.377 219.635Z"
        fill="url(#paint34_linear_7074_113690)"
      />
      <path
        d="M44.4664 97.1887C31.3202 109.316 29.3992 126.16 23.6624 142.482C22.635 140.552 21.7907 138.531 21.1404 136.444C18.3439 122.305 27.6743 104.102 40.7421 98.1688C41.9517 97.7315 43.1981 97.4035 44.4664 97.1887Z"
        fill="url(#paint35_linear_7074_113690)"
      />
      <path
        d="M55.8862 277.223V235.406L57.5328 234.74C60.5253 237.354 63.5962 239.823 66.4711 242.581C66.9677 243.038 66.8109 244.423 66.641 245.325C64.7747 256.462 61.1442 267.23 55.8862 277.223Z"
        fill="url(#paint36_linear_7074_113690)"
      />
      <path
        d="M152.981 97.8693C159.28 97.3205 168.113 104.495 172.896 114.099C177.274 122.92 179.299 132.028 174.517 142.626C168.623 126.279 166.767 109.369 152.981 97.8693Z"
        fill="url(#paint37_linear_7074_113690)"
      />
      <path
        d="M76.5602 214.577C65.2827 206.815 54.3451 187.03 56.0439 179.294C61.1664 184.43 66.3413 190.009 71.9605 195.119C75.332 198.19 77.1875 201.339 76.6256 206.018C76.4218 208.866 76.3999 211.725 76.5602 214.577Z"
        fill="url(#paint38_linear_7074_113690)"
      />
      <path
        d="M121.5 214.773C121.5 209.872 121.278 205.704 121.605 201.561C121.944 199.951 122.78 198.488 123.996 197.379C128.021 193.263 132.268 189.382 136.293 185.292C138.306 183.253 140.044 180.927 141.86 178.758C143.951 186.468 133.301 205.847 121.5 214.773Z"
        fill="url(#paint39_linear_7074_113690)"
      />
      <path
        d="M46.4906 447.026C44.06 436.702 42.5702 426.549 44.2952 415.859C45.7326 406.712 45.027 397.172 45.2622 387.816C45.2622 386.352 45.2622 384.876 45.2622 383.412L46.3208 383.268C46.5952 384.732 46.9611 386.195 47.1179 387.672C47.9934 396.388 48.1371 405.248 49.8359 413.808C52.1358 425.386 48.5684 436.062 46.4906 447.026Z"
        fill="url(#paint40_linear_7074_113690)"
      />
      <path
        d="M153.503 383.568C153.503 394.336 152.575 405.196 153.777 415.833C154.811 425.422 154.406 435.112 152.575 444.582C152.46 445.267 152.299 445.944 152.091 446.607C152.091 446.803 151.686 446.908 151.098 447.313C149.19 435.63 145.871 424.444 148.485 412.435C150.183 404.438 150.197 396.074 151.007 387.868C151.151 386.417 151.438 384.967 151.66 383.516L153.503 383.568Z"
        fill="url(#paint41_linear_7074_113690)"
      />
      <path
        d="M146.159 94.1054C140.592 94.2753 135.156 98.5354 129.746 94.5758C117.201 85.4284 115.698 83.2722 115.947 75.2878C123.983 85.6114 135.718 88.617 146.159 94.1054Z"
        fill="url(#paint42_linear_7074_113690)"
      />
      <path
        d="M82.2834 76.5408C82.7277 86.3677 74.1552 89.6085 68.2355 94.5089C63.0868 98.7952 57.4938 94.2737 52.0576 94.5874L51.8486 93.5681C57.0757 91.2681 62.6295 89.3472 67.6344 86.5507C72.6394 83.7542 77.2392 80.0429 82.2834 76.5408Z"
        fill="url(#paint43_linear_7074_113690)"
      />
      <path
        d="M187.439 180.431C180.618 169.637 175.339 148.571 177.965 142.599C185.009 149.734 189.726 168.539 187.439 180.431Z"
        fill="url(#paint44_linear_7074_113690)"
      />
      <path
        d="M21.0876 142.521C20.8916 146.127 21.3881 149.943 20.3819 153.315C17.6638 162.462 14.3055 171.479 11.0124 181.097C8.15056 170.643 11.2084 157.274 19.5326 142.508L21.0876 142.521Z"
        fill="url(#paint45_linear_7074_113690)"
      />
      <path
        d="M122.167 195.851C122.624 191.931 122.86 188.782 123.474 185.659C123.637 185.159 123.907 184.701 124.266 184.317C124.625 183.933 125.064 183.633 125.552 183.437C131.001 181.621 134.255 177.622 136.921 172.839C137.926 171.431 139.058 170.118 140.305 168.919C141.677 177.138 136.463 184.77 122.167 195.851Z"
        fill="url(#paint46_linear_7074_113690)"
      />
      <path
        d="M58.161 169.128C59.3611 170.486 60.47 171.922 61.4803 173.427C64.0938 177.896 67.3084 181.555 72.3395 183.411C72.863 183.645 73.33 183.989 73.7088 184.42C74.0876 184.851 74.3694 185.358 74.535 185.907C75.1753 188.978 75.4236 192.127 75.9855 196.492C67.8443 187.919 57.2855 182.588 57.1548 169.951L58.161 169.128Z"
        fill="url(#paint47_linear_7074_113690)"
      />
      <path
        d="M113.255 78.5661L117.972 98.0632L105.126 101.278L112.065 78.1741L113.255 78.5661Z"
        fill="url(#paint48_linear_7074_113690)"
      />
      <path
        d="M85.8645 78.085L93.0258 101.176L79.958 98.1571C81.6176 91.401 83.1988 84.9063 84.793 78.3986L85.8645 78.085Z"
        fill="url(#paint49_linear_7074_113690)"
      />
      <path
        d="M87.1584 291.01C93.6008 296.094 93.3525 301.243 91.2356 307.005C89.1186 312.768 87.6418 318.374 85.8776 324.059L84.8062 323.889C85.5772 313.134 86.3482 302.379 87.1584 291.01Z"
        fill="url(#paint50_linear_7074_113690)"
      />
      <path
        d="M110.942 291.702C111.648 302.513 112.358 313.329 113.072 324.149L112.04 324.398C109.766 316.217 107.035 308.102 105.506 299.791C105.035 297.308 107.858 294.211 109.165 291.388L110.942 291.702Z"
        fill="url(#paint51_linear_7074_113690)"
      />
      <path
        d="M47.7847 146.415C52.8681 154.256 59.7809 159.731 62.0808 168.8C51.9663 165.037 46.9615 157.431 47.7847 146.415Z"
        fill="url(#paint52_linear_7074_113690)"
      />
      <path
        d="M136.018 168.971C138.37 159.549 145.166 154.087 150.04 146.821C152.457 157.72 145.009 164.972 136.018 168.971Z"
        fill="url(#paint53_linear_7074_113690)"
      />
      <path
        d="M75.1231 173.309C74.7834 176.092 74.4566 178.68 74.1169 181.502C68.8898 180.496 66.1325 176.654 63.2446 173.126C63.1341 172.763 63.1157 172.378 63.191 172.006C63.2663 171.635 63.4328 171.287 63.6758 170.996C64.0219 170.726 64.4196 170.53 64.8444 170.42C65.2691 170.31 65.712 170.288 66.1456 170.356C69.0858 171.179 71.9607 172.25 75.1231 173.309Z"
        fill="url(#paint54_linear_7074_113690)"
      />
      <path
        d="M124.036 181.619C123.644 178.796 123.278 176.235 122.873 173.321C126.075 172.249 129.041 171.152 132.02 170.315C132.449 170.266 132.884 170.315 133.291 170.458C133.698 170.6 134.068 170.833 134.373 171.139C134.591 171.454 134.724 171.821 134.758 172.204C134.793 172.586 134.727 172.971 134.569 173.321C131.837 176.758 129.067 180.338 124.036 181.619Z"
        fill="url(#paint55_linear_7074_113690)"
      />
      <path
        d="M56.3309 544.069C59.1536 556.784 59.1274 556.862 50.751 559.214C52.3322 553.817 53.7697 548.878 55.2071 543.938L56.3309 544.069Z"
        fill="url(#paint56_linear_7074_113690)"
      />
      <path
        d="M142.658 543.846C144.174 548.76 145.676 553.686 147.284 558.953C140.018 557.541 139.103 556.104 140.567 549.622C140.985 547.767 141.299 545.872 141.651 544.003L142.658 543.846Z"
        fill="url(#paint57_linear_7074_113690)"
      />
      <path
        d="M104.878 74.1777C102.879 76.9612 103.415 81.757 98.8541 81.5479C94.5417 81.3388 94.9337 76.8958 93.4048 74.1777H104.878Z"
        fill="url(#paint58_linear_7074_113690)"
      />
      <path
        d="M53.3525 174.406L47.4458 162.645C53.8751 165.037 55.9528 168.852 54.7245 173.753L53.3525 174.406Z"
        fill="url(#paint59_linear_7074_113690)"
      />
      <path
        d="M150.576 162.659L144.238 175.178C141.755 169.742 143.271 166.658 149.465 161.953L150.576 162.659Z"
        fill="url(#paint60_linear_7074_113690)"
      />
      <path
        d="M148.734 173.467L146.055 185.162C143.442 178.341 144.095 175.91 148.734 173.467Z"
        fill="url(#paint61_linear_7074_113690)"
      />
      <path
        d="M51.8496 184.873C51.0786 181.331 50.3075 177.79 49.4712 173.896C53.7836 175.699 54.4632 178.13 53.0257 184.703L51.8496 184.873Z"
        fill="url(#paint62_linear_7074_113690)"
      />
      <path
        d="M79.266 88.8789C78.887 95.2429 77.2143 96.7196 71.0986 96.1577L79.266 88.8789Z"
        fill="url(#paint63_linear_7074_113690)"
      />
      <path
        d="M60.0032 198.634L55.9783 199.418L54.188 190.114L55.2858 189.643C56.7494 192.44 58.213 195.236 60.0032 198.634Z"
        fill="url(#paint64_linear_7074_113690)"
      />
      <path
        d="M126.819 95.947C120.99 96.9663 119.344 95.5942 118.638 88.8381L126.819 95.947Z"
        fill="url(#paint65_linear_7074_113690)"
      />
      <path
        d="M143.729 190.193C143.245 193.029 142.749 195.877 142.2 199.092L138.005 198.883C139.704 195.538 141.154 192.663 142.605 189.736L143.729 190.193Z"
        fill="url(#paint66_linear_7074_113690)"
      />
      <path
        d="M126.949 33.2474C126.087 36.7495 125.238 40.2648 124.336 43.78L122.951 43.4794L124.989 32.8684L126.949 33.2474Z"
        fill="url(#paint67_linear_7074_113690)"
      />
      <path
        d="M73.0576 32.9731L75.1092 43.7671L73.8809 44.0677C72.9531 40.4871 72.0122 36.9196 71.0713 33.3391L73.0576 32.9731Z"
        fill="url(#paint68_linear_7074_113690)"
      />
      <path
        d="M95.7049 262.796C84.9632 252.159 81.2389 238.503 78.3901 224.286C84.0615 225.122 89.3541 225.867 94.6334 226.742C95.0039 226.838 95.3469 227.019 95.6351 227.271C95.9232 227.523 96.1485 227.839 96.2931 228.193C98.4561 239.647 98.2558 251.422 95.7049 262.796Z"
        fill="url(#paint69_linear_7074_113690)"
      />
      <path
        d="M102.382 262.693C99.9806 251.648 99.6837 240.25 101.506 229.095C101.736 228.518 102.1 228.004 102.568 227.595C103.037 227.186 103.595 226.894 104.198 226.743C109.099 225.776 114.077 225.11 119.553 224.247C117.044 238.465 112.94 251.951 102.382 262.693Z"
        fill="url(#paint70_linear_7074_113690)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7074_113690"
          x1="181.743"
          y1="486.868"
          x2="119.998"
          y2="486.868"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7074_113690"
          x1="78.4424"
          y1="486.535"
          x2="16.2529"
          y2="486.535"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7074_113690"
          x1="122.807"
          y1="36.4373"
          x2="74.4565"
          y2="36.4373"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_7074_113690"
          x1="84.9886"
          y1="306.348"
          x2="50.335"
          y2="306.348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_7074_113690"
          x1="147.629"
          y1="306.943"
          x2="112.951"
          y2="306.943"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_7074_113690"
          x1="97.7923"
          y1="129.212"
          x2="43.98"
          y2="129.212"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_7074_113690"
          x1="154.107"
          y1="129.442"
          x2="99.7822"
          y2="129.442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_7074_113690"
          x1="142.318"
          y1="249.549"
          x2="56.5933"
          y2="249.549"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_7074_113690"
          x1="197.722"
          y1="273.082"
          x2="169.695"
          y2="273.082"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_7074_113690"
          x1="27.8017"
          y1="273.404"
          x2="-9.97693e-08"
          y2="273.404"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_7074_113690"
          x1="176.82"
          y1="171.721"
          x2="156.665"
          y2="171.721"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_7074_113690"
          x1="195.839"
          y1="209.841"
          x2="176.595"
          y2="209.841"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_7074_113690"
          x1="41.3132"
          y1="171.71"
          x2="21.377"
          y2="171.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_7074_113690"
          x1="21.3307"
          y1="210.104"
          x2="2.65039"
          y2="210.104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_7074_113690"
          x1="83.4194"
          y1="362.351"
          x2="61.8052"
          y2="362.351"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_7074_113690"
          x1="135.562"
          y1="362.219"
          x2="114.469"
          y2="362.219"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_7074_113690"
          x1="171.602"
          y1="121.45"
          x2="131.602"
          y2="121.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_7074_113690"
          x1="66.7337"
          y1="121.121"
          x2="25.7271"
          y2="121.121"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_7074_113690"
          x1="57.8649"
          y1="347.117"
          x2="41.9863"
          y2="347.117"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_7074_113690"
          x1="156.202"
          y1="347.163"
          x2="140.095"
          y2="347.163"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_7074_113690"
          x1="113.952"
          y1="333.051"
          x2="100.762"
          y2="333.051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_7074_113690"
          x1="97.0044"
          y1="331.888"
          x2="84.2388"
          y2="331.888"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_7074_113690"
          x1="133.602"
          y1="162.85"
          x2="63.4541"
          y2="162.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_7074_113690"
          x1="31.5413"
          y1="233.141"
          x2="13.6699"
          y2="233.141"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_7074_113690"
          x1="121.146"
          y1="191.638"
          x2="99.7861"
          y2="191.638"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_7074_113690"
          x1="97.9921"
          y1="191.569"
          x2="76.9453"
          y2="191.569"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_7074_113690"
          x1="184.439"
          y1="233.141"
          x2="166.508"
          y2="233.141"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_7074_113690"
          x1="112.953"
          y1="87.9697"
          x2="85.498"
          y2="87.9697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_7074_113690"
          x1="97.3793"
          y1="171.93"
          x2="76.1948"
          y2="171.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_7074_113690"
          x1="121.893"
          y1="172.27"
          x2="100.478"
          y2="172.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_7074_113690"
          x1="69.3207"
          y1="389.857"
          x2="48.355"
          y2="389.857"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_7074_113690"
          x1="149.502"
          y1="390.029"
          x2="127.512"
          y2="390.029"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_7074_113690"
          x1="142.944"
          y1="256.742"
          x2="131.307"
          y2="256.742"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_7074_113690"
          x1="97.2488"
          y1="211.54"
          x2="78.5728"
          y2="211.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_7074_113690"
          x1="119.808"
          y1="211.554"
          x2="100.961"
          y2="211.554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_7074_113690"
          x1="44.4664"
          y1="119.836"
          x2="20.6431"
          y2="119.836"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_7074_113690"
          x1="66.806"
          y1="255.983"
          x2="55.8862"
          y2="255.983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_7074_113690"
          x1="177.274"
          y1="120.234"
          x2="152.981"
          y2="120.234"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_7074_113690"
          x1="76.725"
          y1="196.936"
          x2="55.8687"
          y2="196.936"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_7074_113690"
          x1="142.124"
          y1="196.766"
          x2="121.427"
          y2="196.766"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_7074_113690"
          x1="50.5812"
          y1="415.148"
          x2="43.5493"
          y2="415.148"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_7074_113690"
          x1="154.335"
          y1="415.416"
          x2="147.52"
          y2="415.416"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_7074_113690"
          x1="146.159"
          y1="85.7722"
          x2="115.923"
          y2="85.7722"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_7074_113690"
          x1="82.3"
          y1="86.4535"
          x2="51.8486"
          y2="86.4535"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_7074_113690"
          x1="188.022"
          y1="161.516"
          x2="177.278"
          y2="161.516"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_7074_113690"
          x1="21.0876"
          y1="161.803"
          x2="9.96533"
          y2="161.803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_7074_113690"
          x1="140.517"
          y1="182.386"
          x2="122.167"
          y2="182.386"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_7074_113690"
          x1="75.9855"
          y1="182.81"
          x2="57.1548"
          y2="182.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_7074_113690"
          x1="117.972"
          y1="89.7265"
          x2="105.126"
          y2="89.7265"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_7074_113690"
          x1="93.0258"
          y1="89.6308"
          x2="79.958"
          y2="89.6308"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_7074_113690"
          x1="92.5748"
          y1="307.535"
          x2="84.8062"
          y2="307.535"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_7074_113690"
          x1="113.072"
          y1="307.894"
          x2="105.454"
          y2="307.894"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_7074_113690"
          x1="62.0808"
          y1="157.608"
          x2="47.6973"
          y2="157.608"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_7074_113690"
          x1="150.501"
          y1="157.896"
          x2="136.018"
          y2="157.896"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_7074_113690"
          x1="75.1231"
          y1="175.91"
          x2="63.1455"
          y2="175.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_7074_113690"
          x1="134.767"
          y1="175.958"
          x2="122.873"
          y2="175.958"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_7074_113690"
          x1="58.0156"
          y1="551.576"
          x2="50.751"
          y2="551.576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_7074_113690"
          x1="147.284"
          y1="551.4"
          x2="139.977"
          y2="551.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_7074_113690"
          x1="104.878"
          y1="77.8663"
          x2="93.4048"
          y2="77.8663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_7074_113690"
          x1="55.0604"
          y1="168.526"
          x2="47.4458"
          y2="168.526"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_7074_113690"
          x1="150.576"
          y1="168.566"
          x2="143.101"
          y2="168.566"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_7074_113690"
          x1="148.734"
          y1="179.315"
          x2="144.53"
          y2="179.315"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_7074_113690"
          x1="53.7072"
          y1="179.384"
          x2="49.4712"
          y2="179.384"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_7074_113690"
          x1="79.266"
          y1="92.5732"
          x2="71.0986"
          y2="92.5732"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_7074_113690"
          x1="60.0032"
          y1="194.531"
          x2="54.188"
          y2="194.531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_7074_113690"
          x1="126.819"
          y1="92.5435"
          x2="118.638"
          y2="92.5435"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_7074_113690"
          x1="143.729"
          y1="194.414"
          x2="138.005"
          y2="194.414"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_7074_113690"
          x1="126.949"
          y1="38.3244"
          x2="122.951"
          y2="38.3244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint68_linear_7074_113690"
          x1="75.1092"
          y1="38.5207"
          x2="71.0713"
          y2="38.5207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint69_linear_7074_113690"
          x1="97.7791"
          y1="243.542"
          x2="78.3901"
          y2="243.542"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
        <linearGradient
          id="paint70_linear_7074_113690"
          x1="119.553"
          y1="243.471"
          x2="100.33"
          y2="243.471"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};

export default MenBodyMeasurement;
